import { PagedResponseModel } from '../PagedResponseModel';

export class PagedPublishingList extends PagedResponseModel {
    public list: PublishingListItem[];
    public currentPage: number;
    public PageSize: number;
    public totalRecords: number;
}

export class PublishingListItem {
    publishingId: string;
    createdDate: Date;
    publishDate: Date;
    volumeIssue: string;
    publishedBy: string;
    status: string;
    year: string;
}

